import { Form } from 'factorial-form'

class WorkInformation extends Form {
  constructor(values: {}) {
    super(values, {
      manager_id: 'number',
      location_id: 'number',
      employee_group_id: 'number',
      timeoff_manager_id: 'number',
      payrollable: 'boolean',
      company_identifier: 'string',
      contract_version_starts_on: 'date',
      show_birthday: 'boolean',
      seniority_calculation_date: 'string',
    })
  }
}

export default WorkInformation
